import styled from "styled-components";

export const Styles = styled.div`
    table {
        th:first-child {
            width: 5%;
        }
    }
`;
